module.exports = __webpack_public_path__ + "dental candidate dashboard.png?f1cfe3980fe11c06139dd38baaf83380";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/dental candidate dashboard.png
// module id = 31
// module chunks = 0